var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2656 4.68604C18.7539 4.68523 21.1808 5.45792 23.2106 6.89716C25.2403 8.3364 26.7725 10.371 27.595 12.7194L16.2656 16.686V4.68604Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26563 16.686C4.26562 18.2619 4.57601 19.8223 5.17907 21.2782C5.78213 22.7341 6.66604 24.057 7.78034 25.1713C8.89465 26.2856 10.2175 27.1695 11.6734 27.7726C13.1293 28.3756 14.6898 28.686 16.2656 28.686C17.8415 28.686 19.4019 28.3756 20.8578 27.7726C22.3137 27.1695 23.6366 26.2856 24.7509 25.1713C25.8652 24.057 26.7491 22.7341 27.3522 21.2782C27.9552 19.8223 28.2656 18.2619 28.2656 16.686C28.2656 13.5034 27.0013 10.4512 24.7509 8.20075C22.5005 5.95032 19.4482 4.68604 16.2656 4.68604C13.083 4.68604 10.0308 5.95032 7.78034 8.20075C5.52991 10.4512 4.26563 13.5034 4.26563 16.686Z",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.512d17d736771c3bee7af20637cce753.svg";
export { ForwardRef as ReactComponent };